// Matchup intelligence tab — pitcher vs pitcher + bullpen availability
import type { MLBProbablePitcher, TeamLineup } from '../../types';
import { PitchingIntelligence } from './PitchingIntelligence';
import { BullpenAnalytics, type BullpenData } from './BullpenAnalytics';
import { LineupCorrelation } from './LineupCorrelation';

interface Props {
  awayPitcher?: MLBProbablePitcher;
  homePitcher?: MLBProbablePitcher;
  awayBullpen?: BullpenData;
  homeBullpen?: BullpenData;
  awayLineup?: TeamLineup;
  homeLineup?: TeamLineup;
  awayTeamAbbr: string;
  homeTeamAbbr: string;
}

export function MatchupWorkspace({
  awayPitcher,
  homePitcher,
  awayBullpen,
  homeBullpen,
  awayLineup,
  homeLineup,
  awayTeamAbbr,
  homeTeamAbbr,
}: Props) {
  return (
    <div className="space-y-6">
      <PitchingIntelligence
        awayPitcher={awayPitcher}
        homePitcher={homePitcher}
        awayTeamAbbr={awayTeamAbbr}
        homeTeamAbbr={homeTeamAbbr}
      />
      <BullpenAnalytics awayBullpen={awayBullpen} homeBullpen={homeBullpen} />
      <LineupCorrelation
        awayLineup={awayLineup}
        homeLineup={homeLineup}
        awayTeamAbbr={awayTeamAbbr}
        homeTeamAbbr={homeTeamAbbr}
      />
    </div>
  );
}
